import "./bootstrap";
import "./plugins";
import Vue from "vue";
import Vuex from "vuex";
import vuexI18n from "vuex-i18n";
import "./core/coreApp";
import "./app/AppComponents";
import "./app/DemoComponent";
import VueCookies from "vue-cookies";
import LottieAnimation from "lottie-vuejs";
import wysiwyg from "vue-wysiwyg";
import drag from "v-drag";
import "vue-wysiwyg/dist/vueWysiwyg.css";
import VueSignaturePad from "vue-signature-pad";
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import '../js/app/Helpers/Helpers'
import PrimeVue from 'primevue/config';
import "primevue/resources/themes/lara-light-indigo/theme.css";
import VueRecaptcha from 'vue-recaptcha';

Vue.component('vue-recaptcha', VueRecaptcha);
// import 'primevue/resources/primevue.min.css';
// import 'primeicons/primeicons.css'; 

// import * as Sentry from "@sentry/vue";

// Sentry.init({
//   app,
//   dsn: "https://a38ce206cb99206c1bba7c1cdd105e1c@o4505709064749056.ingest.sentry.io/4505709110755328",
//   integrations: [
//     new Sentry.BrowserTracing({
//       // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//       tracePropagationTargets: ["localhost", "https:yourserver.io/api/"],
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//     }),
//     new Sentry.Replay(),
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

Vue.filter('formatDate', function (value) {  // for formating date only
  if (value) {
    return moment(String(value)).format('MMM Do, YYYY')
  }
});
Vue.filter('compareMonthDate2Today', function (value) {  // checking if time now is one month after value
  if (value) {
    let time_now = new Date();
    let one_month = moment(String(value)).add(30, 'days');
    if (moment(time_now).isAfter(String(one_month))) {
      return "Expired"  //
    }
    else {
      return "Valid"  //
    }

  }
});
Vue.filter('formatDateTime', function (value) {  // for formating date and time
  if (value) {
    return moment(String(value)).format('MMM Do, YYYY - HH:mm:ss')
  }
});
Vue.filter('formatDateAddMonth', function (value) {  // for formating time
  if (value) {
    return moment(String(value)).add(30, 'days').format('MMM Do, YYYY')
  }
});

// truncate filter
var filter = function (text, length, clamp) {
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.use(PrimeVue);

Vue.filter('truncate', filter);

Vue.component('paginate', Paginate)

Vue.use(VueSignaturePad);

Vue.use(drag, {});

// import * as VueGoogleMaps from "vue2-google-maps";

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: "AIzaSyAJEWOkg4njiqY71jR-xxs-PnQI9yXaYsQ",
//     libraries: "places",
//   },
// });

Vue.use(wysiwyg, {
  hideModules: { image: true },
}); // config is optional. more below

Vue.use(LottieAnimation);


import { ColorPicker, ColorPanel } from 'one-colorpicker'

Vue.use(ColorPanel)
Vue.use(ColorPicker)

const appName = window.settings?.business_info.company_name;
Vue.prototype.$appName = appName;
let webOrApi = window.location.href.split("?");

if (webOrApi.includes("token")) {
  Vue.prototype.$webOrApi = "api";
} else {
  Vue.prototype.$webOrApi = "app";
}

window.Vue = Vue;

import VueChatScroll from "vue-chat-scroll";
Vue.use(VueChatScroll);
/**
 * vuex
 */

Vue.use(Vuex);
import storeData from "./store/Index";
// import storeData from "./store/Index";
const store = new Vuex.Store(storeData);

/**
 * localization
 * $t('key') or this.$('key')
 * link: https://github.com/dkfbasel/vuex-i18n
 * */

Vue.use(vuexI18n.plugin, store);
Vue.use(VueCookies);

import ReadMore from 'vue-read-more';

Vue.use(ReadMore);

import VTooltip from 'v-tooltip'

Vue.use(VTooltip)
import VPopover from 'vue-js-popover'
Vue.use(VPopover, { tooltip: true })
//get the customisation options


import FloatingVue from 'floating-vue'

Vue.use(FloatingVue)
import 'floating-vue/dist/style.css'

import './design.css'
// add translations directly to the application
let language = JSON.parse(window.localStorage.getItem("app-languages"));
let key = window.localStorage.getItem("app-language");
Vue.i18n.add(key, language);
// set the start locale to use
Vue.i18n.set(key);

/*------ localization end ------*/



const app = new Vue({
  store,
  el: "#app",
  created() {
    const customizationOptions = window.localStorage.getItem('customizationOptions');

    if (customizationOptions) {
      const options = JSON.parse(customizationOptions);


      this.$store.commit('setCustomizationOptions', options);
      this.$store.commit('START_WORKER', {});

      // Use the retrieved options as needed
    }
    this.$store.dispatch("getConfig");
  },
});
